module.exports = __webpack_public_path__ + "cancellara-dist/img/eudaimon.8feb3e1a.png";